import { Newspaper } from "lucide-react";
import dayjs from "dayjs";
import type { StrapiArticle } from "./types";
import {
  Card,
  CardDescription,
  CardHeader,
  CardIcon,
  CardTitle,
} from "components/ui/card";
import { Badge } from "components/ui/badge";
import { TruncatedText } from "components/shared/truncated-text";

interface ArticleCardProps {
  article: StrapiArticle;
  onClick?: () => void;
}

export const ArticleCard = ({ article, onClick }: ArticleCardProps) => {
  const dateToDisplay = article.displayPublishDate || article.publishedAt;
  const formattedDate = dayjs(dateToDisplay).fromNow();

  return (
    <Card
      className={`pt-0 ${onClick ? "cursor-pointer hover:bg-accent/50 transition-colors" : ""}`}
      onClick={onClick}
    >
      {article.cover ? (
        <img
          src={article.cover.url}
          alt={article.cover.alternativeText || article.title}
          className="h-40 w-full object-cover rounded-t-lg"
        />
      ) : (
        <div className="h-40 bg-linear-to-br from-muted to-muted-foreground/20 flex items-center justify-center rounded-t-lg">
          <Newspaper className="size-10 text-muted-foreground" />
        </div>
      )}
      <CardHeader>
        <CardIcon variant="top" className="flex justify-between min-w-full">
          {article.category && (
            <Badge variant="secondary" className="text-xs">
              {article.category.name}
            </Badge>
          )}
          <span className="text-xs text-muted-foreground">{formattedDate}</span>
        </CardIcon>
        <CardTitle className="text-base min-w-0">
          <TruncatedText className="max-w-full">{article.title}</TruncatedText>
        </CardTitle>
        <CardDescription className="text-sm line-clamp-3">
          {article.description}
        </CardDescription>
      </CardHeader>
    </Card>
  );
};
